@if (!actionItems) {
  <!-- Separate to different component without form-group div etx -->
  @if (label) {
    <div class="sh-form-group__label" [ngClass]="{ '-sh-is-required': required }">
      <label [for]="for"><sh-field-label [label]="label" [labelIcons]="labelIcons()"></sh-field-label></label>
    </div>
  }
  @if (helpText) {
    <em class="sh-form-group__label__em">{{ helpText }}</em>
  }
} @else {
  <div class="sh-action-group" style="margin-bottom: 0px">
    <div class="sh-action-group__item">
      @if (label) {
        <div class="sh-form-group__label" [ngClass]="{ '-sh-is-required': required }" style="margin-bottom: 0px">
          <label [for]="for"><sh-field-label [label]="label" [labelIcons]="labelIcons()"></sh-field-label></label>
        </div>
      }
    </div>
    <div class="sh-action-group__item">
      @for (actionItem of actionItems; track actionItem) {
        <sh-action-item [item]="actionItem" style="margin-bottom: 0.625rem"></sh-action-item>
      }
    </div>
  </div>
  @if (helpText) {
    <em class="sh-form-group__label__em">{{ helpText }}</em>
  }
}

